import { render, staticRenderFns } from "./invidi-goal-form-app.vue?vue&type=template&id=6ce7fc98&scoped=true"
import script from "./invidi-goal-form-app.vue?vue&type=script&lang=js"
export * from "./invidi-goal-form-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce7fc98",
  null
  
)

export default component.exports